import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

/**
 * The '/login' route has no real page of its own — the actual login form only ever renders as a
 * popup over the home page, shown by HomeComponent when the URL fragment is '#login'. Someone
 * arriving at bare '/login' (a bookmark, an old email link, browser back/forward) bypasses that
 * flow entirely, so this sends them through the same working path instead of rendering nothing.
 */
@Injectable({ providedIn: 'root' })
export class LoginRedirectGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    return this.router.createUrlTree([''], { fragment: 'login' });
  }
}
